export default __webpack_public_path__ + "static/media/proto.96050e84.jpg";